import * as React from 'react';
import ServiceList from "./ServiceList";
import {Subbar, Title, PageHeader} from "ah-tools";

class ServiceNotAssignedList extends React.Component {
	
	render = () => {
	
		return (
			<React.Fragment>
				<PageHeader align={Subbar.ALIGN_BETWEEN}>
					<Subbar>
						<Title>Nicht zugewiesene Dienste (Liste)</Title>
					</Subbar>
				</PageHeader>
				<ServiceList services={[]} />
			</React.Fragment>
		);
	};
}

export default ServiceNotAssignedList;


// WEBPACK FOOTER //
// ./src/components/ServiceNotAssignedList.js